import type { CSSProperties } from "react";

import { cn } from "../../lib/utils";

type TableShellProps = {
  children: React.ReactNode;
  className?: string;
};

export function TableShell({ children, className }: TableShellProps) {
  return (
    <div
      className={cn(
        "relative bg-surface-850 rounded-xl border border-surface-700/30 overflow-hidden",
        className,
      )}
    >
      <div className="absolute inset-0 noise-overlay rounded-xl" />
      {children}
    </div>
  );
}

type TableHeaderProps = {
  children: React.ReactNode;
  columns: string;
  className?: string;
  style?: CSSProperties;
};

export function TableHeader({ children, columns, className, style }: TableHeaderProps) {
  return (
    <div
      className={cn(
        "relative grid items-center px-5 py-3 border-b border-surface-700/40 bg-surface-825",
        className,
      )}
      style={{ gridTemplateColumns: columns, ...style }}
    >
      {children}
    </div>
  );
}

type TableHeaderLabelProps = {
  children: React.ReactNode;
  className?: string;
};

export function TableHeaderLabel({ children, className }: TableHeaderLabelProps) {
  return (
    <span
      className={cn(
        "text-xs font-display font-bold uppercase tracking-widest text-surface-400",
        className,
      )}
    >
      {children}
    </span>
  );
}
